import { render } from "./WCMainSidebar.vue?vue&type=template&id=d7b37aaa&scoped=true"
import script from "./WCMainSidebar.vue?vue&type=script&lang=js"
export * from "./WCMainSidebar.vue?vue&type=script&lang=js"

import "./WCMainSidebar.vue?vue&type=style&index=0&id=d7b37aaa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b37aaa"]])

export default __exports__